(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bubblzz-floating-elements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bz-footer-elements')) {
    customElements.define('bz-footer-elements', class extends HTMLElement {
      connectedCallback() {
        this.layer = this.querySelector('.bz-float-layer');
        if (!this.layer) return;
        this.update = this.update.bind(this);
        this.schedule = this.schedule.bind(this);
        this.mount = this.mount.bind(this);
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(document.body);
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule);
        document.addEventListener('shopify:section:load', this.mount);
        this.mount();
      }
      mount() {
        let matches;
        try {
          matches = document.querySelectorAll(this.dataset.footerSelector || 'footer');
        } catch {
          this.layer.hidden = true;
          return;
        }
        const target = matches[matches.length - 1];
        if (!target) { this.layer.hidden = true; return; }
        this.footer = target;
        if (getComputedStyle(target).position === 'static') target.classList.add('bz-footer-position');
        target.append(this.layer);
        this.layer.hidden = false;
        this.schedule();
      }
      schedule() {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      }
      update() {
        this.frame = null;
        if (!this.footer?.isConnected) { this.layer.hidden = true; return; }
        const rect = this.footer.getBoundingClientRect();
        const gap = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
        if (rect.top < window.innerHeight && rect.bottom > 0 && gap <= 120) {
          this.layer.dataset.landed = 'true';
        } else if (gap > 300 || rect.top >= window.innerHeight) {
          this.layer.dataset.landed = 'false';
        }
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        document.removeEventListener('shopify:section:load', this.mount);
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.layer?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  if (!customElements.get('bz-cart-addons')) {
    customElements.define('bz-cart-addons', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', (event) => event.stopPropagation());
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-bz-add]');
          if (button) this.addProduct(button);
        });
      }
      async addProduct(button) {
        if (this.busy) return;
        this.busy = true;
        const buttons = this.querySelectorAll('[data-bz-add]');
        buttons.forEach((item) => { item.disabled = true; });
        const status = this.querySelector('.bz-addons-status');
        const originalLabel = button.textContent;
        button.textContent = this.dataset.loading;
        status.textContent = '';
        const variantId = button.dataset.variantId;
        const note = document.querySelector('[name="note"]');
        const noteValue = note?.value;
        const footer = document.querySelector('#main-cart-footer');
        const footerSection = footer?.dataset.id || footer?.closest('.shopify-section')?.id.replace('shopify-section-', '');
        const sectionIds = [...new Set([this.dataset.sectionId, footerSection, 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean))];
        let added = false;
        try {
          const response = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds, sections_url: this.dataset.cartUrl })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          added = true;
          const parser = new DOMParser();
          const replacements = [];
          for (const id of sectionIds) {
            const html = result.sections?.[id];
            const current = document.getElementById('shopify-section-' + id);
            if (current) {
              if (!html) throw new Error(this.dataset.error);
              const next = parser.parseFromString(html, 'text/html').getElementById('shopify-section-' + id);
              if (!next) throw new Error(this.dataset.error);
              replacements.push([current, next]);
            } else if (id === 'cart-icon-bubble' || id === 'cart-live-region-text') {
              const target = document.getElementById(id);
              if (target && html) {
                const parsed = parser.parseFromString(html, 'text/html');
                replacements.push([target, parsed.getElementById(id) || parsed.querySelector('.shopify-section')]);
              }
            }
          }
          for (const [current, next] of replacements) {
            if (next) {
              if (next.id === current.id) current.replaceWith(next);
              else current.innerHTML = next.innerHTML;
            }
          }
          const updatedNote = document.querySelector('[name="note"]');
          if (updatedNote && noteValue !== undefined) updatedNote.value = noteValue;
          document.querySelector('bz-cart-addons [data-bz-add]')?.focus({ preventScroll: true });
        } catch (error) {
          if (added) {
            window.location.reload();
            return;
          }
          status.textContent = error.message || this.dataset.error;
          button.textContent = originalLabel;
          buttons.forEach((item) => { item.disabled = false; });
        } finally {
          this.busy = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
